module.exports = __webpack_public_path__ + "static/media/TM.d4a5d466.svg";